import script from "./CommentSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommentSection.vue?vue&type=script&setup=true&lang=ts"

import "./CommentSection.vue?vue&type=style&index=0&id=6a21ca2a&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a21ca2a"]])

export default __exports__